module.exports = __webpack_public_path__ + "img/rewards-coin.blue.15e270bc.svg";